//components
import "./components/Header/index.js";
import "./components/Header/search.js";
import "./components/Footer/index.js";

//pages
import "./pages/styles/index.js";
import "./pages/contacts/index.js";
import "./pages/news/index.js";
import "./pages/company/index.js";
import "./pages/search/index.js";


import "./sections/contactsSlider/index.js";
